export * from './individuals-destruction-form/individuals-destruction-form.component';
